import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import { CanActivate } from '@angular/router';
import {LoginService} from "./login.service";
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {Observable} from "rxjs/Observable";
//import * as moment from 'moment';
declare let moment: any;

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(
    private login: LoginService,
    private router: Router,
    private func: Funcoes,
    public global: Global
  ) {
  }

  canActivate(next:ActivatedRouteSnapshot, state:RouterStateSnapshot) {

    return this.login.getUserInfo().map(data => {


      if(this.global.debug == true){
        console.log(localStorage.getItem('token'));
      }

      let token: any = localStorage.getItem('token');

      if(token){

        token = token.split('.');

        let expira = JSON.parse(atob(token[1]));

        expira = moment.unix(expira.exp);
        let now = moment();
        
        console.log('LoginGuard - Horário Atual (Now):', now.format('YYYY-MM-DD HH:mm:ss'));
        console.log('LoginGuard - Horário Expira (Exp):', expira.format('YYYY-MM-DD HH:mm:ss'));

        /* 
           Removido bloqueio por expiração no cliente devido a desalinhamento de relógios (Server vs Client).
           A API já valida a expiração e retornará 401 caso o token seja inválido.
        */
        console.log('LoginGuard - Token recebido, verificando permissões...');

        let url = state.url.split('/');
        let target = '';

        if(url[2] == 'usuarios' && url[3] == 'cargos'){
          target = 'cargos';
        }else if(url[2] == 'faturas'){
          target = 'financeiro';
        }else if(url[2] == 'unidades-medidas'){
          target = 'mercadorias';
        }else{
          target = url[2];
        }

        // remove parametros get da url
        target = target.split('?')[0];

        let liberado = (target == 'dashboard' || target == '' || !target)?true:false;
        
        console.log('LoginGuard - URL:', state.url);
        console.log('LoginGuard - Target identificado:', target);
        console.log('LoginGuard - Liberado inicial:', liberado);

        const mercadoInternoTargets = [
          'certificados-nacionais',
          'terminais-nacionais',
          'mercado-interno-mercadorias',
          'assinantes',
          'laboratorios'
        ];

        for(let i in data.privilegios){
          const p = data.privilegios[i];
          const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
          const idAcao = String(p.id_acao || '');

          const isMercadoInternoMatch = mercadoInternoTargets.indexOf(target) >= 0 && (
            idAcao === '20' ||
            acaoUrl === 'prestacao-mapa' ||
            acaoUrl === 'certificados-nacionais' ||
            acaoUrl === 'mercado-interno'
          );

          if(acaoUrl == target || isMercadoInternoMatch){
            if(p.consultar || p.editar){
              liberado = (state.url.indexOf('/upd') >= 0 && p.editar == false) ? false : true;
            }
          }
        }
        
        console.log('LoginGuard - Liberado final:', liberado);

        if (this.func.userIsMaster()) {
          liberado = true;
        }

        if(liberado){
          return true
        }else{

          // libera acesso a alteracao dos dados do proprio user
          if(url[2] == 'usuarios' && this.login.getUserInfo(true).id_usuario == url[3]){
            console.log('LoginGuard - Liberado por ser alteração do próprio usuário');
            return true;
          }

          console.warn('LoginGuard - Acesso NEGADO para o target:', target);

          if(this.func.getTokenInfo()['adm'] == 1){
            this.router.navigateByUrl('/nao-autorizado');
          }else{
            if(target == 'area-cliente'){
              return true;
            }
            this.router.navigateByUrl('/nao-autorizado-cliente');
          }
          return false;
        }

      }else{

        if(this.func.getTokenInfo()['adm'] == 1){
          this.router.navigateByUrl('/nao-autorizado');
        }else{
          this.router.navigateByUrl('/nao-autorizado-cliente');
        }

        return false;
      }

    }).catch((err) => {
      console.error('LoginGuard - Erro crítico na verificação:', err);
      this.router.navigateByUrl('/nao-autorizado');
      return Observable.of(false);
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/login/login-guard.service.ts